/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { TranslationsBaseService } from '../translations-base-service';
import { TranslationsApiConfiguration } from '../translations-api-configuration';
import { TranslationsStrictHttpResponse } from '../translations-strict-http-response';

import { textsControllerTranslateTexts } from '../fn/texts/texts-controller-translate-texts';
import { TextsControllerTranslateTexts$Params } from '../fn/texts/texts-controller-translate-texts';
import { TranslationsTranslateTextsResponseDto } from '../models/translations-translate-texts-response-dto';

@Injectable({ providedIn: 'root' })
export class TranslationsTextsService extends TranslationsBaseService {
  constructor(config: TranslationsApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `textsControllerTranslateTexts()` */
  static readonly TextsControllerTranslateTextsPath = '/o2-translations/texts/{tenant}';

  /**
   * Translate a batch of texts from Italian to English.
   *
   * Translates user-entered free-text values (item names, descriptions, notes, ...) via AWS Translate for the English document export. The response array is index-aligned with the request array; empty strings pass through unchanged.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `textsControllerTranslateTexts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textsControllerTranslateTexts$Response(params: TextsControllerTranslateTexts$Params, context?: HttpContext): Observable<TranslationsStrictHttpResponse<TranslationsTranslateTextsResponseDto>> {
    const obs = textsControllerTranslateTexts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Translate a batch of texts from Italian to English.
   *
   * Translates user-entered free-text values (item names, descriptions, notes, ...) via AWS Translate for the English document export. The response array is index-aligned with the request array; empty strings pass through unchanged.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `textsControllerTranslateTexts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  textsControllerTranslateTexts(params: TextsControllerTranslateTexts$Params, context?: HttpContext): Observable<TranslationsTranslateTextsResponseDto> {
    const resp = this.textsControllerTranslateTexts$Response(params, context);
    return resp.pipe(
      map((r: TranslationsStrictHttpResponse<TranslationsTranslateTextsResponseDto>): TranslationsTranslateTextsResponseDto => r.body)
    );
  }

}
